export default __webpack_public_path__ + "static/media/gallery_03.61d4fee0.jpg";